module.exports = __webpack_public_path__ + "media/images/lit-73399faa73da0d9cc353f021880348b2.svg";